<template>
  <div>
    <el-dialog
      title="添加问答"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose"
    >
      <div class="card">
        <div class="col-lg-12 list-header fix-header clearfix">
          <div class="dsply-fix fix-header-item">
            <b-form-input
              v-model="pageParams.contentKeyword"
              class="w-190 m-r-10"
              size="sm"
              type="text"
              placeholder="请输入关键字"
            ></b-form-input>
            <b-button
              class="m-r-5"
              size="sm"
              variant="primary"
              @click="getList()"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
        </div>
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px;"></th>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col" style="width: 70px;">名称</th>
                  <th scope="col">封面</th>
                  <th scope="col">题目数</th>
                  <th scope="col">标签</th>
                  <th scope="col">使用次数</th>
                  <th scope="col">创建日期</th>
                  <th scope="col">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="media-dialog-radio">
                    <b-form-radio
                      name="qa_radio"
                      @change="checkCoupon(item)"
                    ></b-form-radio>
                  </td>
                  <td>{{ item.id }}</td>
                  <td style="width: 70px;">{{ item.title }}</td>
                  <td>
                    <img
                      v-if="item.image"
                      class="avatar-sm"
                      :src="`${item.image}`"
                      alt
                    />
                    <img
                      v-if="!item.image"
                      class="avatar-sm"
                      src="../../../assets/images/image-null.jpg"
                      alt=""
                    />
                  </td>
                  <td>{{ item.questionNum || 0 }}</td>
                  <td>
                    <template v-if="item.tag">{{
                      item.tag.split(",").length
                    }}</template>
                    <template v-else>0</template>
                  </td>
                  <td>{{ item.userNum || 0 }}</td>
                  <td>{{ item.createAt || "--" }}</td>
                  <td>
                    <ul class="list-inline font-size-22 contact-links mb-0">
                      <li
                        class="list-inline-item px-2"
                        @click="viewQa(item.id)"
                      >
                        <a v-b-tooltip.hover title="查看">
                          <i class="bx bx-show"></i>
                        </a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <pagination ref="page" @pageCallback="pageCallback"></pagination>
        <app-list-loading ref="loading"></app-list-loading>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="查看问答"
      :visible.sync="showQa"
      class="top-draft-dialog"
      :before-close="qaClose"
    >
      <div class="card">
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col">问题</th>
                  <th scope="col">正确答案</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in answers" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.question || "--" }}</td>
                  <td>{{ item.answerRight || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import question from "../../../server/api/question";
import pagination from "@/components/pagination/pagination.vue";

export default {
  components: {
    pagination,
  },

  data() {
    return {
      pageParams: {
        contentKeyword: null,
        page: 1,
        pageSize: 5,
        state: "1",
        showState: null,
        tagId: null,
        type: "2",
        order: null,
        sortBy: null,
      },
      selectItem: {},
      items: [],
      show: false,
      showQa: false,
      answers: [],
    };
  },

  props: {},

  mounted() {},

  methods: {
    showModel() {
      this.resetParams();
      this.selectItem = {};
      this.show = true;
      this.showQa = false;
      this.answers = [];
    },

    handleClose() {
      this.show = false;
    },

    //获取列表数据
    getList() {
      let params = this.utils.getQuery(this.pageParams);
      question.list(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data) {
            if (resp.data.items) {
              this.items = resp.data.items;
              console.log(this.items);
              if (this.$refs.loading) {
                this.$refs.loading.hide(resp.data.items);
              }
              let pages = {
                page: resp.data.page, //第几页
                pageSize: resp.data.pageSize, //每页多少条
                total: resp.data.total, //全部有多少条数据
                totalPages: resp.data.totalPages, //全部有几页
              };
              this.$nextTick(() => {
                if (this.$refs.page) {
                  this.$refs.page.setPages(pages);
                }
              });
            }
          }
        }
      });
    },

    submitCreate() {
      let current = {
        code: "qa",
        item: this.selectItem,
      };
      this.handleClose();
      this.$emit("pageCallback", current);
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //重置搜索参数
    resetParams() {
      this.pageParams = {
        contentKeyword: null,
        page: 1,
        pageSize: 5,
        state: "1",
        showState: null,
        tagId: null,
        type: "2",
        order: null,
        sortBy: null,
      };
      this.getList();
    },
    checkCoupon(item) {
      this.selectItem = item;
    },
    viewQa(id) {
      question.qadetail({ id: id }).then((resp) => {
        if (resp.code == 0) {
          if (resp.data) {
            console.log(resp);
            this.answers = resp.data.qaBankList;
          }
        }
      });
      this.showQa = true;
    },
    qaClose() {
      this.showQa = false;
    },
  },
};
</script>
